import { z } from "zod"

const schema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  // Offline-dev LOGIN fallback flag (PLA-86). When `true`, the login form
  // accepts any non-empty credentials and synthesizes a local admin session
  // so a developer without a running backend can still get into the app.
  // Default is `false` (real login posts to /api/admin/auth/login). This flag
  // NO LONGER gates the dashboard data source — that is an in-app toggle
  // ("Datos reales" vs "Demo") that defaults to real. Vite exposes env vars
  // as strings, so we coerce "true"/"false" to a boolean here.
  VITE_ADMIN_MOCK: z
    .string()
    .transform((v) => v === "true")
    .default("false"),
})

const parsed = schema.safeParse(import.meta.env)
if (!parsed.success) {
  // Bootstrap before the logger exists — console.error is the sanctioned
  // boundary per logging-discipline.md §A.
  console.error("Invalid env:", parsed.error.flatten())
  throw new Error("Invalid environment variables. See src/env.ts")
}

// The mock login synthesizes a PLATFORM_SUPERUSER session in the browser.
// It is a developer convenience and nothing else; a production bundle that
// carries it on is a misconfigured build, so refuse to boot rather than ship
// a console that any visitor can "enter".
if (import.meta.env.PROD && parsed.data.VITE_ADMIN_MOCK) {
  console.error("VITE_ADMIN_MOCK must be false in a production build")
  throw new Error("VITE_ADMIN_MOCK cannot be enabled in a production build. See src/env.ts")
}

export const env = parsed.data
